import { login, logout, getInfo } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { resetRouter } from "@/router";
import { isLoginApi } from "@/api/sms";
import Cookies from "js-cookie";
import { oAuth, getQueryString } from "@/libs/wechat";

const state = {
  token: getToken(),
  name: "",
  avatar: "",
  introduction: "",
  roles: [],
  isLogin: Cookies.get("isLogin"),
  operatorRole: [],
  staffTypes: [],
  BalanceReminder: sessionStorage.getItem("BalanceReminder") || 1 //合同余额提醒  1提醒  0不提醒
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_ISLOGIN: (state, isLogin) => {
    state.isLogin = isLogin;
    Cookies.set(isLogin);
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_OPERATORROLE: (state, operatorRole) => {
    state.roles.push(...operatorRole);
  },
  SET_STAFFTYPES: (state, staffTypes) => {
    state.staffTypes = staffTypes;
  },
  SET_BR: (state, value) => {
    state.BalanceReminder = value;
    sessionStorage.setItem("BalanceReminder", value);
  }
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { account, pwd, key, code, wxCode } = userInfo;
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then(data => {
          commit("SET_TOKEN", data.token);
          Cookies.set("JavaInfo", JSON.stringify(data));
          sessionStorage.setItem("BalanceReminder", 1);
          console.log(JSON.stringify(data));
          setToken(data.token);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // 短信是否登录
  isLogin({ commit }, userInfo) {
    // const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      isLoginApi()
        .then(async res => {
          commit("SET_ISLOGIN", res.status);
          resolve(res);
        })
        .catch(res => {
          commit("SET_ISLOGIN", false);
          reject(res);
        });
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then(data => {
          if (!data) {
            reject("Verification failed, please Login again.");
          }
          const { roles, opeatorRole, account } = data;
          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            reject("getInfo: roles must be a non-null array!");
          }
          Cookies.set("JavaInfo", JSON.stringify(data));
          // console.log(state);
          commit("SET_ROLES", roles.split(","));
          // commit('SET_ROLES', ['admin'])
          commit("SET_NAME", account);
          // commit('SET_AVATAR', avatar)
          commit(
            "SET_AVATAR",
            "http://kaifa.crmeb.net/system/images/admin_logo.png"
          );
          commit("SET_INTRODUCTION", "CRMEB admin");
          console.log(opeatorRole);
          commit("SET_OPERATORROLE", opeatorRole.split(","));
          const staffTypes = [];
          // if (state.roles.indexOf('ys') != -1) {   修改前根据info信息的权限判断，临时方案改为全部展示
          staffTypes.push(
            ...[
              {
                label: "月嫂",
                value: 1
              },
              {
                label: "育婴师",
                value: 2
              },
              {
                label: "保姆",
                value: 4
              }
            ]
          );
          // }
          // if (state.roles.indexOf('bm') != -1) {
          //   staffTypes.push(...[{
          //     label: "保姆",
          //     value: 4
          //   }])
          // }
          commit("SET_STAFFTYPES", staffTypes);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit("SET_TOKEN", "");
          commit("SET_ROLES", []);
          removeToken();
          resetRouter();
          // localStorage.clear();
          Cookies.remove("storeStaffList");
          Cookies.remove("JavaInfo");
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("BalanceReminder");
          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          dispatch("tagsView/delAllViews", null, { root: true });

          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      removeToken();
      resolve();
    });
  },
  // 设置token
  setToken({ commit }, state) {
    return new Promise(resolve => {
      commit("SET_TOKEN", state.token);
      Cookies.set("JavaInfo", JSON.stringify(state));
      setToken(data.token);
      resolve();
    });
  },
  //设置不再提醒
  setBalanceReminder({ commit }, state) {
    commit("SET_BR", state);
  },

  // dynamically modify permissions
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const token = role + "-token";

      commit("SET_TOKEN", token);
      setToken(token);

      const { roles } = await dispatch("getInfo");

      resetRouter();

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch("permission/generateRoutes", roles, {
        root: true
      });

      // dynamically add accessible routes
      router.addRoutes(accessRoutes);

      // reset visited views and cached views
      dispatch("tagsView/delAllViews", null, { root: true });

      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
